import Link from "next/link";

export default function Footer() {
  const year = new Date().getFullYear();
  
  return (
    <footer className="main-footer bg-black/90 py-12 px-5 text-center border-t-2 border-secondary relative z-10">
      <p className="mb-6 opacity-80">© {year} Becoming Wind. Alle Rechte vorbehalten.</p>
      <nav className="footer-nav flex flex-wrap justify-center gap-8">
        <Link href="/archiv" className="hover:text-accent transition-colors opacity-70 hover:opacity-100">Archiv</Link>
        <Link href="/impressum" className="hover:text-accent transition-colors opacity-70 hover:opacity-100">Impressum</Link>
        <Link href="/datenschutz" className="hover:text-accent transition-colors opacity-70 hover:opacity-100">Datenschutz</Link>
      </nav>
    </footer>
  );
}
